import { colors } from '@proprioo/salatim';

import { AreaFiltered, LocationSearchType, LocationState } from '../interfaces';

export const OPTIONS_MAP: google.maps.MapOptions = {
  clickableIcons: false,
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false,
  styles: [{ featureType: 'poi', stylers: [{ visibility: 'off' }] }]
};

export const STYLE_POLYGON_AREA = {
  clickable: true,
  draggable: false,
  editable: false,
  fillColor: colors.dark.base60,
  fillOpacity: 0.3,
  geodesic: true,
  strokeColor: colors.dark.base80,
  strokeOpacity: 1,
  strokeWeight: 1.2,
  visible: true,
  zIndex: 0
};

export const STYLE_POLYGON_AREA_HIDE = {
  ...STYLE_POLYGON_AREA,
  clickable: false,
  visible: false
};

export const STYLE_POLYGON_AREA_SELECTED = {
  ...STYLE_POLYGON_AREA,
  fillColor: colors.terracota.base80,
  fillOpacity: 0.3,
  strokeColor: colors.terracota.base,
  zIndex: 1
};

export const filterArea = <T extends AreaFiltered>(areas: T[]) =>
  areas.filter(
    ({ type }) =>
      type === LocationSearchType.NEIGHBORHOOD ||
      type === LocationSearchType.IRIS
  );

export const cleanDuplicatedPolygons = (areas: LocationState[]) =>
  areas.filter(
    (area, index, arr) => arr.findIndex(({ id }) => id === area.id) === index
  );
